export function IconX(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.79279 6.79302C6.98031 6.60555 7.23462 6.50023 7.49979 6.50023C7.76495 6.50023 8.01926 6.60555 8.20679 6.79302L11.9998 10.586L15.7928 6.79302C15.885 6.69751 15.9954 6.62133 16.1174 6.56892C16.2394 6.51651 16.3706 6.48892 16.5034 6.48777C16.6362 6.48662 16.7678 6.51192 16.8907 6.5622C17.0136 6.61248 17.1253 6.68673 17.2192 6.78062C17.3131 6.87452 17.3873 6.98617 17.4376 7.10907C17.4879 7.23196 17.5132 7.36364 17.512 7.49642C17.5109 7.6292 17.4833 7.76042 17.4309 7.88242C17.3785 8.00443 17.3023 8.11477 17.2068 8.20702L13.4138 12L17.2068 15.793C17.3889 15.9816 17.4897 16.2342 17.4875 16.4964C17.4852 16.7586 17.38 17.0094 17.1946 17.1948C17.0092 17.3802 16.7584 17.4854 16.4962 17.4877C16.234 17.49 15.9814 17.3892 15.7928 17.207L11.9998 13.414L8.20679 17.207C8.01818 17.3892 7.76558 17.49 7.50339 17.4877C7.24119 17.4854 6.99038 17.3802 6.80497 17.1948C6.61956 17.0094 6.51439 16.7586 6.51211 16.4964C6.50983 16.2342 6.61063 15.9816 6.79279 15.793L10.5858 12L6.79279 8.20702C6.60532 8.01949 6.5 7.76518 6.5 7.50002C6.5 7.23486 6.60532 6.98055 6.79279 6.79302Z"
        fill="currentColor"
      />
    </svg>
  );
}
